module.exports = __webpack_public_path__ + "assets/img/jtfx52.56db3702.png";